import React from 'react';
import { cn } from '../index';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('block text-xs font-medium text-[var(--fg)] mb-1.5', className)}
      {...props}
    >
      {children}
      {required && <span className="text-[var(--destructive)] ml-0.5">*</span>}
    </label>
  ),
);
Label.displayName = 'Label';

export interface FormFieldProps {
  label?: string;
  htmlFor?: string;
  required?: boolean;
  error?: string;
  hint?: string;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label, htmlFor, required, error, hint, children, className,
}) => (
  <div className={cn('w-full', className)}>
    {label && (
      <Label htmlFor={htmlFor} required={required}>
        {label}
      </Label>
    )}
    {children}
    {hint && !error && <p className="mt-1 text-xs text-[var(--fg-muted)]">{hint}</p>}
    {error && <p className="mt-1 text-xs text-[var(--destructive)]">{error}</p>}
  </div>
);
